exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.embed .wrap[data-v-23590679] {\n  margin-top: 1em;\n  font-size: 0.9em;\n  line-height: 1.5em;\n}\n.embed .wrap code[data-v-23590679] {\n    background-color: #E0E6ED;\n    padding: 0.2em 0.3em;\n    border-radius: 2px;\n}\n", ""]);

// exports
